/**
 * L'INDIRIZZO DI UN ASSET DELLA SCENA, risolto contro la radice della scena.
 *
 * Gli indirizzi che tornano dalla scena — texture e foto dei materiali — sono relativi alla sua
 * radice quando non sono già assoluti. La risoluzione è una sola e sta qui perché la usano file
 * che non devono dipendere l'uno dall'altro.
 *
 * UNA BARRA INIZIALE NON VUOL DIRE «RADICE DEL DOMINIO». Qui `textures/…` e `/textures/…` sono la
 * stessa cosa, e sono tutte e due relative alla SCENA. La regola di prima riconosceva lo schema —
 * qualunque schema, barra compresa — e trattava la seconda forma come già assoluta: il browser la
 * risolveva contro il backoffice, `http://localhost:9001/textures/…` invece del CDN, e restava un
 * rettangolo rotto al posto dell'anteprima mentre la stessa texture, in 3D, si vedeva benissimo.
 *
 * RESTANO INTATTI GLI SCHEMI VERI: `http:`, `https:`, e soprattutto `data:` e `blob:`, che sono la
 * forma di una texture appena scelta e non ancora salvata da nessuna parte. Incollare la radice
 * davanti a uno di quelli produce un indirizzo che non esiste.
 */
export const sceneAssetUrl = (rootUrl: string, url: string): string => {
    if (!url || /^(?:https?:|data:|blob:)/i.test(url)) return url;
    if (!rootUrl) return url;

    try {
        return new URL(url.replace(/^\/+/, ''), rootUrl.endsWith('/') ? rootUrl : rootUrl + '/').href;
    } catch {
        return url;
    }
};

/** Il nome del file in fondo a un indirizzo, senza la query. */
export const fileNameOf = (url?: string | null) => {
    if (!url) return null;
    const clean = url.split('?')[0];
    return clean.substring(clean.lastIndexOf('/') + 1) || clean;
};
